















import { LessonsService } from '../../biz/remote/LessonsService';
import { Vue, Component, Prop } from 'vue-property-decorator';
import DaReportPage from '../../components/report/DaReportPage.vue';
import { MessageDialog } from '../../utils/MessageDialog';

@Component({ components: { DaReportPage } })
export default class StudentDailyReportPage extends Vue {
  created() {
    const class_id_param = this.$route.query.class_id as string;
    if (!class_id_param) {
      MessageDialog.systemError('レッスンID', '日報表示時', class_id_param).then();
      return;
    }

    // 引数は文字列になっているので数値化
    const class_id = parseInt(class_id_param);

    const biz = new LessonsService();
    biz.studentShown(class_id);
  }
}
